import React from "react";
import { Div, Text, Row, Col, Image, Button, Anchor } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import AnimateLink from "../common/AnimateLink";
import PricingScheduleDemo from "../common/PricingScheduleDemo";
import {
  getUTMcookie,
  addUtmToUrl,
  addUtmInputValues,
} from "../../utilities/helpers";

const PricingPoints = ({
  points,
  campaign,
  footer,
  getStarted,
  scheduleDemoButton,
  features,
}) => {
  const pointsLeft = points.points.slice(0, points.points.length / 2);
  const pointsRight = points.points.slice(
    points.points.length / 2,
    points.points.length
  );

  return (
    <WebsiteContainer>
      <Div
        maxW="48.75rem"
        m={{ b: { xs: "6.7rem", md: "0" }, x: "auto" }}
        bg="black800"
        border="1px solid"
        borderColor="border"
      >
        <Div
          p="2.4rem"
          border={{
            t: "1px solid",
            y: "1px solid",
            b: { xs: "none", md: "1px solid" },
          }}
          borderColor="border"
          d="flex"
          flexDir={{ xs: "column", md: "row" }}
          align="flex-start"
        >
          <Div
            textAlign="center"
            border={{
              r: { xs: "none", md: "1px solid" },
              b: { xs: "1px solid", md: "none" },
            }}
            borderColor="#393939"
            p={{ r: { xs: "0", md: "3.5rem" }, b: { xs: "2.5rem", md: "0" } }}
            flexGrow="1"
          >
            <Text
              d="inline-block"
              textSize="heading2"
              textWeight="bold"
              className="white-text-gradient"
            >
              {features.creator.title}
            </Text>
            <Text textSize="body" textColor="white" m={{ t: "0.3rem" }}>
              {features.creator.text}
            </Text>
          </Div>
          <Div
            textAlign="center"
            p={{ l: { xs: "0", md: "3.5rem" }, y: { xs: "2.5rem", md: "0" } }}
            flexGrow="1"
            border={{
              b: { xs: "1px solid", md: "none" },
            }}
            borderColor="#393939"
          >
            <Text
              d="inline-block"
              textSize="heading2"
              textWeight="bold"
              className="white-text-gradient"
              flexGrow="1"
            >
              {features.software.title}
            </Text>
            <Text textSize="body" textColor="white" m={{ t: "0.3rem" }}>
              {features.software.text}
            </Text>
          </Div>
        </Div>
        <Div
          p={{ xs: "0 2.4rem 2.4rem", md: "0.7rem 2.4rem 2.4rem" }}
          border={{
            b: "1px solid",
            y: "1px solid",
            t: { xs: "none", md: "1px solid" },
          }}
          borderColor="border"
        >
          <Div d="flex" flexDir={{ xs: "column", md: "row" }}>
            <Div flexGrow="1 1 50%" p={{ r: "1rem" }}>
              {pointsLeft.map((data, index) => {
                return (
                  <Div key={index} d="flex" m={{ t: "1.75rem" }}>
                    <Image
                      src={data.image}
                      h="20px"
                      w="20px"
                      m={{ r: "11px" }}
                    />
                    <Text
                      textSize="paragraph2"
                      textWeight="bold"
                      style={{ lineHeight: "21px" }}
                    >
                      {data.point}
                    </Text>
                  </Div>
                );
              })}
            </Div>
            <Div flexGrow="1 1 50%" p={{ l: { xs: "0", md: "3.9rem" } }}>
              {pointsRight.map((data, index) => {
                return (
                  <Div key={index} d="flex" m={{ t: "1.75rem" }}>
                    <Image
                      src={data.image}
                      h="20px"
                      w="20px"
                      m={{ r: "11px" }}
                    />
                    <Text
                      textSize="paragraph2"
                      textWeight="bold"
                      style={{ lineHeight: "21px" }}
                    >
                      {data.point}
                    </Text>
                  </Div>
                );
              })}
            </Div>
          </Div>
        </Div>
      </Div>

      <Div
        d={{ xs: "none", md: "block" }}
        maxW="48.75rem"
        m={{ t: "1.6rem", b: "7.25rem", x: "auto" }}
      >
        <PricingScheduleDemo footer={footer} />
      </Div>
    </WebsiteContainer>
  );
};

export default PricingPoints;
